import {observable, action, computed, flow} from "mobx";
import axios from "axios";

export class MobxStore {
    @observable listingStats;
    @observable residentialPres;
    @observable mapMarkerShowId = '';
    @observable listingDetail;
    @observable posting = false;
    @observable featuredPres;
    @observable landPres;

    @action
    setMapMarkerId = (id) => {
        this.mapMarkerShowId = id;
    }

    @action.bound
    getListingStats = flow(function*() {
        const response = yield axios.get('api/Listing/ActiveListingCount');
        this.listingStats = response.data;
    })

    @action.bound
    getResidentialPres = flow(function*() {
        const response = yield axios.get('api/Listing/ResidentialPres');
        this.residentialPres = response.data;
    })

    @action.bound
    getFeaturedPres = flow(function*() {
        const response = yield axios.get('api/Listing/FeaturedPres');
        this.featuredPres = response.data;
    })

    @action.bound
    getLandPres = flow(function*() {
        const response = yield axios.get('api/Listing/LandPres');
        this.landPres = response.data;
    })

    @action.bound
    getListingDetail = flow(function*(id) {
        const response = yield axios.get(`api/Listing/ListingDetail?id=${id}`);
        this.listingDetail = response.data;
    })

    @action.bound
    sendRequestMoreInfo = flow(function*(rmi) {
        this.posting = true;
        const response = yield axios.post(`api/Listing/RequestMoreInfo`, rmi);
        console.log(response.data);
        this.posting = false;
    })

    @action
    clearFeaturedPres = () => {
        this.featuredPres = [];
    }

    @action.bound
    searchProperties = flow(function*(params) {
        this.posting = true;
        this.clearFeaturedPres();

        const response = yield axios.post(`api/Listing/SearchProperties`, params);

        this.featuredPres = response.data;
        this.posting = false;
    })
}


// WEBPACK FOOTER //
// ./src/stores/mobxStore.js